import { styled } from '@mui/material/styles'

const Container = styled('div')({
  display: 'inline-flex',
  flexDirection: 'column',
})

export default Container
